import { TreatString } from "./treatString";

export class TreatDate {

    constructor(){}

    public static getDataAtualCompleta = (): string => {
        var data: Date = new Date();
        var dataCompleta: string;

        dataCompleta = TreatDate.getDiaSemana(data.getUTCDay()) + ", " + data.getUTCDate() + " de " + TreatDate.getMesNome(data.getMonth()) + " de " + data.getFullYear();

        return dataCompleta;
    }

    public static getDataHora = (): string => {
        var data: Date = new Date();
        var dataHora: string;

        dataHora = 
            TreatString.padLeft(data.getUTCDate().toString(),"0",2) 
            + "/" 
            + TreatString.padLeft((data.getUTCMonth() + 1).toString(),"0",2) 
            + "/" 
            + data.getUTCFullYear() 
            + " - " 
            + TreatString.padLeft(data.getHours().toString(),"0",2) 
            + ":" 
            + TreatString.padLeft(data.getMinutes().toString(),"0",2);

        return dataHora;
    }

    public static getDataSemFormatacao = (data: Date): string => {
        if(data == null){
            return "";
        }
        var dataHora: string;

        dataHora = 
            TreatString.padLeft(data.getUTCDate().toString(),"0",2) 
            + TreatString.padLeft((data.getUTCMonth() + 1).toString(),"0",2) 
            + data.getUTCFullYear();

        return dataHora;
    }

    public static getDataTextSemFormatacao = (data: Date): string => {
        if(data == null){
            return "";
        }
        var dataHora: string;

        dataHora = 
            TreatString.padLeft(data.toString().substr(8, 2),"0",2) 
            + TreatString.padLeft(data.toString().substr(5, 2),"0",2) 
            + data.toString().substr(0, 4);

        return dataHora;
    }

    public static getDataBRSemFormatacao = (data: string): string => {
        if(data == null){
            return "";
        }
        return data.replace("/","").replace("/","");
    }

    public static convertStringtoDate = (data: string) : Date => {
        var parts: string[] = data.split("/");
        return new Date(
            parts[2] + "-" + 
            parts[1] + "-" + 
            parts[0] + "T00:00:00");
    }

    public static validaData = (data: string): boolean => {
        if(data == null || data.trim() == "") {
            return false;
        }
        var parts: string[] = data.split("/");
        var day = parseInt(parts[0], 10);
        var month = parseInt(parts[1], 10);
        var year = parseInt(parts[2], 10);

        // Check the ranges of month and year
        if(year < 1000 || year > 3000 || month == 0 || month > 12){
            return false;
        }

        var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

        // Adjust for leap years
        if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)){
            monthLength[1] = 29;
        }

        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1];
    }

    public static getMesNome = (mes: number): string => {
        mes++;
        if(mes == 1){
            return "Janeiro";
        }
        else if(mes == 2){
            return "Fevereiro";
        }
        else if(mes == 3){
            return "Março";
        }
        else if(mes == 4){
            return "Abril";
        }
        else if(mes == 5){
            return "Maio";
        }
        else if(mes == 6){
            return "Junho";
        }
        else if(mes == 7){
            return "Julho";
        }
        else if(mes == 8){
            return "Agosto";
        }
        else if(mes == 9){
            return "Setembro";
        }
        else if(mes == 10){
            return "Outubro";
        }
        else if(mes == 11){
            return "Novembro";
        }
        else if(mes == 12){
            return "Dezembro";
        }
    }

    public static getDiaSemana = (dia: number): string => {
        dia++;
        if(dia == 1){
            return "Domingo";
        }
        else if(dia == 2){
            return "Segunda";
        }
        else if(dia == 3){
            return "Terça";
        }
        else if(dia == 4){
            return "Quarta";
        }
        else if(dia == 5){
            return "Quinta";
        }
        else if(dia == 6){
            return "Sexta";
        }
        else if(dia == 7){
            return "Sábado";
        }
    }
}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/util/treatDate.ts